import { Injectable, signal } from '@angular/core';
export type SideSnackbarType = 'info' | 'warning' | 'error';

@Injectable()
export class SeSideSnackbarStateService {
    closable = signal<boolean>(true);
    message = signal<string | null>(null);
    type = signal<SideSnackbarType>('info');

    private timeoutId?: number;

    constructor() { }

    show(message: string, type: SideSnackbarType = 'info', closable: boolean = true, duration = 5000) {
        this.message.set(message);
        this.type.set(type);
        this.closable.set(closable);

        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }

        if (duration > 0) {
            this.timeoutId = window.setTimeout(() => this.clear(), duration);
        }
    }

    clear() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
        }

        this.message.set(null);
    }
}
